{
  "label": "aplicación",
  "name": "Nombre",
  "model": {
    "declination": "Gama",
    "type": "Tipo"
  },
  "versionNumber": "Número de versión",
  "serialNumber": "Número de serie",
  "terminalName": "Nombre del terminal",
  "windowsUserAccount": "Cuenta Windows del usuario",
  "sector": "Red",
  "connectivity": "Conectividad",
  "certificate": "Certificado",
  "state": "Estado",
  "states": {
    "activated": "Activado",
    "deactivated": "Desactivado",
    "registered": "Nuevo"
  },
  "actions": {
    "scheduled": {
      "title": "¿Acciones en curso?",
      "yes": "Sí",
      "no": "No",
      "error": "Indeterminado"
    }
  },
  "additionalMetadata": {
    "title": "Metadatos adicionales",
    "username": "Nombre de usuario",
    "installationDate": "Fecha de instalación",
    "computerName": "Nombre del ordenador",
    "licenseId": "Número de licencia : {value}",
    "options": {
      "title": "Opciones",
      "numericSoftware": {
        "1": "Estaciones remotas autorizadas : {value}",
        "2": "Fecha de caducidad de la licencia : {value}"
      }
    }
  },
  "firmwareVersion": "Versión de software",
  "updateCertificate": "Actualización del certificado",
  "updateState": {
    "activate": {
      "title": "Activar",
      "execute": "Activar la aplicación",
      "description": "La aplicación {name} se va a activar."
    },
    "deactivate": {
      "title": "Desactivar",
      "execute": "Desactivar la aplicación",
      "description": "La aplicación {name} se va a desactivar.",
      "warning": "Una aplicación desactivada ya no se beneficia de actualizaciones manuales y automáticas de los certificados.",
      "error": "Esta aplicación no puede desactivarse, ya que hay una operación planificado o en curso."
    }
  },
  "month": "{n} mes | {n} mes",
  "year": "{n} año | {n} años",
  "dateFormat": "DD/MM/YYYY HH:mm",
  "empty": "No se ha encontrado ninguna aplicación.",
  "delete": {
    "execute": "Eliminar la aplicación",
    "description": "La aplicación {name} se va a eliminar.",
    "warning": "Las operaciones asociadas a la aplicación también se eliminarán.",
    "error": "Esta aplicación no puede eliminarse, ya que hay una operación planificado o en curso."
  },
  "description": {
    "certificateValidityDate": "Certificate validity date",
    "communicationProtocol": "Communication protocol",
    "configurationApplicationDate": "Configuration application date",
    "connectivity": "Conectividad",
    "firmwareVersion": "Versión de software",
    "firstCommissioningDate": "Fecha de la primera puesta en servicio",
    "gsmFrequencyBand": "Banda de frecuencia GSM",
    "idCard": "DNI",
    "lastChange": "Último cambio",
    "lastConnection": "Última conexión",
    "lastFirmwareUpdate": "Última actualización del firmware",
    "lastRebootDate": "Fecha del último reinicio",
    "mobileNetwork": "Red móvil",
    "model": "Gama",
    "name": "Nombre",
    "serialNumber": "Número de serie",
    "state": "Estado",
    "terminalName": "Nombre del terminal",
    "title": "Descripción",
    "type": "Tipo",
    "windowsUsername": "Nombre de usuario de Windows"
  },
  "certificateForm": {
    "expirationDate": "Fecha de caducidad del certificado",
    "certificateOrigin": "Origen del certificado",
    "lastUpdate": "Última actualización del certificado"
  },
  "operation": {
    "cancelAction": {
      "title": "Anular la operación",
      "confirm": {
        "title": "¿Seguro que quiere anular esta operación?",
        "description": "Esta operación se anulará"
      }
    },
    "updateAction": {
      "title": "Actualizar la operación"
    },
    "unitary": "Unitarios",
    "campaign": "Campañas"
  },
  "back": "volver"
}
